module.exports = __webpack_public_path__ + "static/media/Latest-update1.06423b1c.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/Latest-update1.png
// module id = 1764
// module chunks = 1